import { hasRequiredFields } from '@move-frontend/utils';
import { useSelectCardFormContext } from './useSelectCardFormContext';

export function useSelectCardFormHasRequiredFields() {
	const { watch } = useSelectCardFormContext();
	const values = watch();

	return hasRequiredFields(values, ['tokenizedCardId']);
}
